import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { LocalizationConfig } from '../models/localization-configuration';

@Injectable({
  providedIn: 'root',
})
export class LocalizationSettingService {
  private languageConfigSubj: ReplaySubject<LocalizationConfig>;

  constructor() {
    this.languageConfigSubj = new ReplaySubject<LocalizationConfig>(1);
  }

  public updateSettings(settings: LocalizationConfig): void {
    this.languageConfigSubj.next(settings);
  }

  public getSettings(): Observable<LocalizationConfig> {
    return this.languageConfigSubj.asObservable();
  }
}
